import en from './en'
import ar from './ar'
import he from './he'

const languages = {
    en, he, ar
}

export default languages